import { mediaDownloadUrl } from "../api/client";

/** Shown next to every preview. */
export function DownloadVideo({ mediaId, label = "Download video" }: { mediaId: number | null | undefined; label?: string }) {
  if (mediaId == null) return null;
  return (
    <a className="button" data-testid="download-video" aria-label={label} href={mediaDownloadUrl(mediaId)} download>
      {label}
    </a>
  );
}
